export default __webpack_public_path__ + "static/media/dotted.4d8191e1.svg";